import type { AuditProtocol } from '../types';

// Comment l'appareil parle a la plateforme : OCPP = borne de recharge vue par
// device-service (BootNotification), MQTT = trame binaire via mqtt-service
// (Wattel EM/GE/WE). Une borne peut faire les deux.
const PILL: Record<AuditProtocol, string> = {
  OCPP: 'pill pill-indigo',
  MQTT: 'pill pill-sky',
  'OCPP+MQTT': 'pill pill-orange',
};

export function ProtocolBadge({
  protocol,
}: {
  readonly protocol: AuditProtocol | null | undefined;
}) {
  if (!protocol) {
    return (
      <span className="pill pill-gray" title="Jamais connecte : protocole inconnu">
        <span className="pill-dot" />
        jamais connecte
      </span>
    );
  }
  return (
    <span className={PILL[protocol]} title={`Protocole ${protocol}`}>
      <span className="pill-dot" />
      {protocol}
    </span>
  );
}
